




















































import RegisterPopup from '@/components/ui/popups/user/RegisterPopup/index.vue';
import getPopupController from '@/lib/vuePopup';
import { PopupControllerPublicProperties } from '@/lib/vuePopup/interfaces';
import TakeAway from '@/models/takeAway';
import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import CodeForm from './components/CodeForm.vue';
import PhoneForm from './components/PhoneForm.vue';
import PopupWrapper from '@/components/ui/PopupWrapper/AuthWrapper.vue';
import { sameAs, maxLength, minLength, numeric, required } from 'vuelidate/lib/validators';
import phone from '@/validators/rules/phone';
import userService from '@/api/services/user.service';
import BaseAsyncButton from '@/components/base/BaseAsyncButton.vue';
import {Action, State} from 'vuex-class';
import {ActionMethod} from 'vuex';

@Component({
  name: 'LoginPopup',
  components: {
    BaseAsyncButton,
    PopupWrapper,
    CodeForm,
    PhoneForm,
  },
  validations: {
    phone: {
      required,
      phone,
    },
    code: {
      minLength: minLength(5),
      maxLength: maxLength(5),
      required,
      numeric,
    },
  },
})
export default class LoginPopup extends Vue {
  @Prop({
    type: Boolean,
    default: false,
  })
  private withoutRedirect!: boolean;

  private popupController: PopupControllerPublicProperties = getPopupController();
  private phone: string = '';
  private code: string = '';
  private isPhoneCodeSent: boolean = false;
  private hasError: boolean = false;

  @State('projectId')
  projectId!: string;

  @State('orders', {
    namespace: 'orderHistory',
  })
  orders!: TakeAway[];

  @Watch('phone')
  private onPhoneChanged() {
    this.hasError = false;
  }

  private async getLoginCodeByUserPhone() {
    this.$v.phone.$touch();

    const phoneForm: any = <any> this.$refs.phoneForm;
    phoneForm.$v.$touch();

    if (!this.$v.phone.$invalid) {
      try {
        await userService.getLoginCodeByUserPhone({
          phone: this.phone,
          projectId: this.projectId,
        });

        this.isPhoneCodeSent = true;
      } catch (e) {
        console.log(e);

        if (e.response && 404 === e.response.status) {
          this.popupController.createPopup(RegisterPopup, {
            propsData: {
              currentPhone: this.phone,
              withoutRedirect: this.withoutRedirect,
            },
          });

          this.close();

          return;
        }

        this.hasError = true;
      }
    }
  }

  private async login() {
    this.$v.$touch();

    if (!this.$v.$invalid) {
      try {
        await this.loginAction({
          phone: this.phone,
          projectId: this.projectId,
          code: this.code,
        });

        if (this.withoutRedirect) {
          this.close();

          return;
        }

        if (this.orders.length > 0) {
          this.$router.push({
            name: 'orderHistory',
            params: {
              projectId: this.$route.params.projectId,
            }
          });
        } else if (this.$route.name !== 'takeAwayMenu') {
          this.$router.push({
            name: 'takeAwayMenu',
            params: {
              projectId: this.$route.params.projectId,
              placeId: this.$route.params.placeId,
            }
          });
        }

        this.close();
      } catch (e) {
        this.code = '';
      }
    }
  }

  @Action('login', {
    namespace: 'user'
  })
  private loginAction!: ActionMethod;

  private close() {
    this.$emit('close');
    this.$destroy();
  }
}
